export class GetTotalPartitionedFoldersRequest {
   filePath: string;
   constructor(filePath: string) {
      this.filePath = filePath;
   }
}